export default "__VITE_ASSET__DjQJXSSL__"